export enum ReweighLogHeadersFilterFormErrors {
  XpoDateRangeFutureDate = 'XpoDateRangeFutureDate',
  XpoDateRangeExceededRange = 'XpoDateRangeExceededRange',
  XpoDateRangeUncompleted = 'XpoDateRangeUncompleted',
  XpoProNumberFormat = 'XpoProNumberFormat',
}
